import CryptoJS from 'crypto-js';

const secretKey = "A8BD87ZXCN6WQN7YCM73Y43QHT07BCGI92" //process.env.REACT_APP_ENCRYPTION_KEY;

if (!secretKey) {
  console.error("Encryption key not found. Please set REACT_APP_ENCRYPTION_KEY in your .env file.");
}

/**
 * Encrypts data using AES.
 * @param {string} data The string to encrypt.
 * @returns {string} The encrypted string, safe for URLs.
 */
export const encryptData = (data) => {
  if (!secretKey) return null;
  const ciphertext = CryptoJS.AES.encrypt(data, secretKey).toString();
  // Use a URL-safe version of Base64 encoding
  return encodeURIComponent(ciphertext);
};

/**
 * Decrypts data using AES.
 * @param {string} encryptedData The encrypted string from the URL.
 * @returns {string|null} The decrypted string, or null if decryption fails.
 */
export const decryptData = (encryptedData) => {
  if (!secretKey) return null;
  try {
    const decodedCiphertext = decodeURIComponent(encryptedData);
    const bytes = CryptoJS.AES.decrypt(decodedCiphertext, secretKey);
    const originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
}; 